import React from 'react';
import { Container } from 'reactstrap';

const Footer = () => {
    return (
        <footer className={`text-center bg-light unselectable`} id="Footer">
            <Container className="text-center p-2">
                <span className="text-secondary text-center">
                    © 2025{' '}
                    <a
                        className="bitwerx-link text-secondary"
                        href="https://www.bitwerx.com"
                        target="_blank"
                        rel="noreferrer">
                        Bitwerx, Inc.
                    </a>
                </span>
            </Container>
        </footer>
    );
};

export default Footer;
